<template>
  <page-content-placeholder
    icon="cached"
    prompt-text="Uploads in progress..."
  >
    <template #message>
      References ready for review will appear here.
    </template>
  </page-content-placeholder>
</template>

<script>
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder.vue';
export default {
  name: 'UploadsInProgressPagePlaceholder',
  components: { PageContentPlaceholder },
};
</script>

<style lang="scss" scoped></style>
